"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.promise");
require("core-js/modules/es6.object.to-string");
require("core-js/modules/es6.object.assign");
const regenerator_1 = __importDefault(require("@babel/runtime/regenerator"));
require("regenerator-runtime/runtime");
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try {
    var info = gen[key](arg);
    var value = info.value;
}
catch (error) {
    reject(error);
    return;
} if (info.done) {
    resolve(value);
}
else {
    Promise.resolve(value).then(_next, _throw);
} }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
const react_1 = __importDefault(require("react"));
const atoms_1 = require("@components/atoms");
const Input_1 = require("@components/atoms/Input");
const Modal_1 = require("@components/atoms/Modal");
const _store_1 = __importDefault(require("@store"));
const _api_1 = __importDefault(require("@api"));
const _theme_1 = require("@theme");
const react_stripe_js_1 = require("@stripe/react-stripe-js");
const stripe_js_1 = require("@stripe/stripe-js");
var stripePromise = stripe_js_1.loadStripe(process.env.GATSBY_STRIPE_PUBLIC_KEY);
var PaymentMethodForm = function PaymentMethodForm(_ref) {
    var refreshPaymentMethods = _ref.refreshPaymentMethods, forceDefault = _ref.forceDefault;
    var stripe = react_stripe_js_1.useStripe();
    var stripeElements = react_stripe_js_1.useElements(); // UI
    var _useGlobal = _store_1.default(function (state) {
        return state.notification;
    }, function (actions) {
        return actions.setNotification;
    }), setNotification = _useGlobal[1];
    var _React$useState = react_1.default.useState(false), processing = _React$useState[0], setProcessing = _React$useState[1];
    var _useGlobal2 = _store_1.default(function (state) {
        return state.user;
    }), user = _useGlobal2[0];
    var _React$useState2 = react_1.default.useState((user === null || user === void 0 ? void 0 : user.firstName) + " " + (user === null || user === void 0 ? void 0 : user.lastName)), nameOnCard = _React$useState2[0], setNameOnCard = _React$useState2[1];
    var _React$useState3 = react_1.default.useState(''), postalCode = _React$useState3[0], setPostalCode = _React$useState3[1];
    var cardNumber = stripeElements === null || stripeElements === void 0 ? void 0 : stripeElements.getElement(react_stripe_js_1.CardNumberElement);
    var _React$useState4 = react_1.default.useState(false), cardNumberValid = _React$useState4[0], setCardNumberValid = _React$useState4[1];
    var _React$useState5 = react_1.default.useState(false), cardExpiresValid = _React$useState5[0], setCardExpiresValid = _React$useState5[1];
    var _React$useState6 = react_1.default.useState(false), cardCvcValid = _React$useState6[0], setCardCvcValid = _React$useState6[1];
    var _React$useState7 = react_1.default.useState(false), defaultPaymentMethod = _React$useState7[0], setDefaultPaymentMethod = _React$useState7[1];
    var _React$useState8 = react_1.default.useState(false), formValid = _React$useState8[0], setFormValid = _React$useState8[1];
    react_1.default.useEffect(function () {
        setFormValid(!!cardNumberValid && !!cardExpiresValid && !!cardCvcValid && !!postalCode && !!nameOnCard);
    }, [cardNumberValid, cardExpiresValid, cardCvcValid, postalCode, nameOnCard]); // Setup a payment method for future billing, and process.
    // https://stripe.com/docs/payments/save-and-reuse
    var createPaymentMethod = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ regenerator_1.default.mark(function _callee() {
            var _yield$PriorApi$then$, client_secret, _yield$stripe$confirm, error, setupIntent;
            return regenerator_1.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            if (!(!stripe || !stripeElements)) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return");
                        case 2:
                            setProcessing(true);
                            _context.next = 5;
                            return _api_1.default('createStripeSetupIntent').then(function (r) {
                                return r.json();
                            }).catch(function (e) {
                                return console.log('client secret missing', e);
                            });
                        case 5:
                            _yield$PriorApi$then$ = _context.sent;
                            client_secret = _yield$PriorApi$then$.client_secret;
                            _context.next = 9;
                            return stripe.confirmCardSetup(client_secret, {
                                payment_method: {
                                    card: cardNumber,
                                    /* "Hey where's the expiration date and CVC?"
                                     * Stripe uses 'magic' (it's watching in the iFrames).
                                     */
                                    billing_details: {
                                        name: nameOnCard,
                                        email: user === null || user === void 0 ? void 0 : user.email,
                                        address: {
                                            postal_code: postalCode
                                        }
                                    }
                                }
                            });
                        case 9:
                            _yield$stripe$confirm = _context.sent;
                            error = _yield$stripe$confirm.error;
                            setupIntent = _yield$stripe$confirm.setupIntent;
                            if (!(error || !setupIntent || !setupIntent.payment_method || setupIntent.status !== 'succeeded')) {
                                _context.next = 16;
                                break;
                            }
                            setNotification({
                                type: 'warning',
                                title: 'Payment information error',
                                message: error === null || error === void 0 ? void 0 : error.message
                            });
                            setProcessing(false);
                            throw new Error(error === null || error === void 0 ? void 0 : error.message);
                        case 16:
                            if (!defaultPaymentMethod) {
                                _context.next = 19;
                                break;
                            }
                            _context.next = 19;
                            return _api_1.default('setDefaultPaymentMethod', {
                                id: setupIntent.payment_method
                            });
                        case 19:
                            _api_1.default('syncStripePaymentMethods').then(function () {
                                // ^ Backend never retrieves new payment methods from front end.
                                //   Instead, backend queries Stripe for existing payment methods.
                                setProcessing(false);
                                refreshPaymentMethods();
                            });
                        case 20:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee);
        }));
        return function createPaymentMethod() {
            return _ref2.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ react_1.default.createElement(Modal_1.ModalWrapper, null, /*#__PURE__*/ react_1.default.createElement(Modal_1.ModalContent, null, /*#__PURE__*/ react_1.default.createElement(Modal_1.ModalCopy, null, /*#__PURE__*/ react_1.default.createElement(Modal_1.ModalHeadline, null, "Add Card"), /*#__PURE__*/ react_1.default.createElement(Modal_1.ModalSubhead, null, "Please fill out the following:")), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: nameOnCard,
        label: "Name on card",
        name: "nameOnCard",
        onChange: function onChange(e) {
            return setNameOnCard(e.target.value);
        },
        required: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        required: true,
        label: "Credit Card Number",
        onChange: function onChange(e) {
            return setCardNumberValid(!e.empty && e.complete);
        },
        disabled: processing
    }, /*#__PURE__*/ react_1.default.createElement(react_stripe_js_1.CardNumberElement, {
        className: "stripePadding",
        options: {
            style: _theme_1.stripeInputStyle
        }
    }))), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        type: "text",
        value: postalCode,
        label: "Postal Code",
        name: "postalCode",
        onChange: function onChange(_ref3) {
            var value = _ref3.target.value;
            return setPostalCode(value);
        },
        required: true,
        disabled: processing
    })), /*#__PURE__*/ react_1.default.createElement(Input_1.InputRow, {
        split: "tablet"
    }, /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        label: "Security Code",
        onChange: function onChange(e) {
            return setCardCvcValid(!e.empty && e.complete);
        },
        required: true,
        disabled: processing
    }, /*#__PURE__*/ react_1.default.createElement(react_stripe_js_1.CardCvcElement, {
        className: "stripePadding",
        options: {
            style: _theme_1.stripeInputStyle
        }
    })), /*#__PURE__*/ react_1.default.createElement(atoms_1.Input, {
        label: "Expiry Date (MM/YY)",
        onChange: function onChange(e) {
            return setCardExpiresValid(!e.empty && e.complete);
        },
        required: true,
        disabled: processing
    }, /*#__PURE__*/ react_1.default.createElement(react_stripe_js_1.CardExpiryElement, {
        className: "stripePadding",
        options: {
            style: _theme_1.stripeInputStyle
        }
    }))), !forceDefault && /*#__PURE__*/ react_1.default.createElement(atoms_1.InputCheckbox, {
        name: "defaultPaymentMethod",
        onChange: function onChange() {
            return setDefaultPaymentMethod(!defaultPaymentMethod);
        },
        checked: defaultPaymentMethod || false,
        outline: true,
        largeLabel: true
    }, "Make this my default card"), /*#__PURE__*/ react_1.default.createElement(Modal_1.ModalButtonWrapper, null, /*#__PURE__*/ react_1.default.createElement(atoms_1.Button, Object.assign({
        shadow: true,
        size: "large",
        display: "flex",
        onClick: function onClick() {
            return createPaymentMethod();
        }
    }, {
        processing: processing
    }, {
        disabled: !formValid
    }), "Add Card"))));
};
var PaymentMethodFormWrapper = function PaymentMethodFormWrapper(props) {
    return /*#__PURE__*/ react_1.default.createElement(react_stripe_js_1.Elements, {
        stripe: stripePromise,
        options: {
            fonts: [{
                    cssSrc: 'https://fonts.googleapis.com/css?family=Inter:semibold'
                }]
        }
    }, /*#__PURE__*/ react_1.default.createElement(PaymentMethodForm, props));
}; // Typing
exports.default = PaymentMethodFormWrapper;
